export default __webpack_public_path__ + "static/media/blogIntro.6e989e43.jpg";